import { usePageViewAnalytics } from '@leagueplatform/analytics';
import { useIntl } from '@leagueplatform/locales';
import { Masonry } from '@leagueplatform/masonry';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { MASONRY } from 'common/constants';
import { PageContentWrapper } from 'components/page-content-wrapper.component';
import { PageHeader } from 'components/page-header/page-header.component';
import { useIsAuthenticated } from '@telus-alberta-health-web/shared-module';

export const FindSupportPage = () => {
  usePageViewAnalytics({ screen_name: 'Find Support' });
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: 'STR_FIND_SUPPORT' }));
  const { isAuthenticated } = useIsAuthenticated();
  return (
    <PageContentWrapper>
      <PageHeader
        headingText={formatMessage({ id: 'STR_FIND_SUPPORT' })}
        showBackButton={isAuthenticated === false}
      />
      <Masonry rootNodeId={MASONRY.ROOT_NODE_ID_FIND_SUPPORT} />
    </PageContentWrapper>
  );
};
